export interface IBuocThucHien{
    Id:number,
    TenCongViec:string,
    TenCoQuan:string,
    TenDonVi:string,
    TenLoaiCoQuan:string,
    IdQuyTrinh:number,
    IdCongViec:number, 
    IdCoQuan:number,
    IdDonVi:number,
    TraNguoc:boolean,
    KetThuc:boolean,
    CapNhatDuLieu:boolean,
    ChuyenVuotCap:boolean,
    ChuyenQuyTrinh:boolean,
    HuyYeuCau:boolean,
    TraYeuCau:boolean,
    STT:number,
    ThoiGianXuLy:number,
    Ngay:number,
    Gio:number,
    Phut:number,
    TrangThai:number,
    NumEmail:number,
    IdNhomCoQuan:number,
    Nhom:boolean,
    IdTrangThai:number,
    PhanViec:boolean,
    GiaoViec:boolean,
    GhiChu:string,   
    IdLuongVao:number, 
    IdLuongRa:number,
    IdDieuHuong:number,
    TuChuyen:boolean,
    PhutChuyen:number,
    DiaBan:boolean,
    STT1:number,
    PhanHoiHeThong:number,
    Ids:string;
    XetTGTong:boolean;
}
export class BuocThucHien implements IBuocThucHien{
    Id:number=0;
    TenCongViec:string='';
    TenCoQuan:string='';
    TenDonVi:string='';
    IdQuyTrinh:number=0;
    IdCongViec:number; 
    IdCoQuan:number;
    IdDonVi:number=0;
    TraNguoc:boolean=false;
    KetThuc:boolean=false;
    CapNhatDuLieu:boolean=false;
    ChuyenVuotCap:boolean = false;
    ChuyenQuyTrinh:boolean= false;
    HuyYeuCau:boolean= false;
    TraYeuCau:boolean= false;
    PhanViec:boolean = false;
    GiaoViec:boolean = false;
    STT:number=0;
    ThoiGianXuLy:number=15;
    Ngay:number=0;
    Gio:number=0;
    Phut:number=0;
    TrangThai:number=1;
    NumEmail:number=0;
    IdNhomCoQuan:number=0;
    Nhom:boolean = false;
    TenLoaiCoQuan:string = "";
    IdTrangThai:number;
    GhiChu:string = '';
    IdLuongVao:number=0;
    IdLuongRa:number=0;
    IdDieuHuong:number=0;
    TuChuyen:boolean=false;
    PhutChuyen:number=0;
    DiaBan:boolean = false;
    STT1:number=0;
    PhanHoiHeThong:number=0;
    Ids:string;
    XetTGTong:boolean=false;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/buoc-thuc-hien.ts